import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpErrorResponseAuth } from '../interface/HttpErrorResponseAuth.interface';
import { NotificationService } from '../services/notification.service';
import { AppConstant } from '../utilities/app.constant';
import { AppHelper } from '../utilities/app.helper';

@Injectable({
  providedIn: 'root',
})
export class ResponseInterceptor implements HttpInterceptor {
  constructor(private _notificationService: NotificationService) {}

  counterErrorSetting: number = 0;

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((errorRes: HttpErrorResponseAuth) => {
        let errorMsg = '';
        if (errorRes.error instanceof Error) {
          console.log('This is client side error');
          errorMsg = `Error: ${errorRes?.error?.message}`;
        } else {
          console.log('This is server side error');
          errorMsg = `Error Code: ${errorRes.status},  Message: ${errorRes?.message}`;

          switch (+errorRes.status) {
            case 0: {
              if (errorRes.url && errorRes.url.includes('/ping')) {
                console.log('Error Status Code (Offline): ' + 0);
              } else if (errorRes.url && errorRes.url.includes('/localhost')) {
                if (this.counterErrorSetting < 1) {
                  // Show this error message ONLY 1 Time
                  this._notificationService.setMessage({
                    type: AppConstant.MESSAGE_TYPE.ERROR,
                    header: 'This message only for development',
                    content: 'Oops! Please check your enviroment settings',
                  });
                  this.counterErrorSetting++;
                }
              } else {
                console.log('Error Status Code: ' + 0);
              }
              break;
            }
            case 403: {
              this._notificationService.setMessage({
                type: AppConstant.MESSAGE_TYPE.ERROR,
                header: 'Blocked',
                content: 'Oops! Something went wrong.',
              });
              console.log('Error Status Code: ' + 403);
              break;
            }
            case 401:
              this._notificationService.setMessage({
                type: AppConstant.MESSAGE_TYPE.ERROR,
                header: '401',
                content:
                  'You currently do not have enough permissions to access the system, please contact admin.',
              });
              console.log('Error Status Code: ' + 401);
              break;
            case 400: {
              const backendMessage =
                AppHelper.UtileFunctions.extractErrorMessage(errorRes);
              if (errorRes.error.errorCode === 'permission_not_found') {
                this._notificationService.setMessage({
                  type: AppConstant.MESSAGE_TYPE.WARNING,
                  header: 'Information',
                  content: 'User is not granted permission!',
                });
              } else if (errorRes.error.errorCode === 'mail_validate_error') {
                this._notificationService.setMessage({
                  type: AppConstant.MESSAGE_TYPE.WARNING,
                  header: 'Information',
                  content: backendMessage,
                });
              } else if (
                errorRes.error.errorCode === 'missing_distribution_list'
              ) {
                this._notificationService.setMessage({
                  type: AppConstant.MESSAGE_TYPE.WARNING,
                  header: 'Information',
                  content: backendMessage,
                });
              }
              console.log('Error Status Code: ' + 400);
              break;
            }
            case 404: {
              if (errorRes.error.errorCode === 'not_found') {
                this._notificationService.setMessage({
                  type: AppConstant.MESSAGE_TYPE.WARNING,
                  header: 'Information',
                  content:
                    AppHelper.UtileFunctions.extractErrorMessage(errorRes),
                });
              }
              console.log('Error Status Code: ' + 404);
              break;
            }
            case 419: {
              console.log('Error Status Code: ' + 419);
              break;
            }
            case 500: {
              this._notificationService.setMessage({
                type: AppConstant.MESSAGE_TYPE.ERROR,
                header: 'Internal Server Error',
                content:
                  'An error occurred on the server. Please try refreshing the page or contact your administrator if the issue persists.',
              });
              break;
            }
            case 503: {
              // Wait to confirm AC

              // In case have error -- Server Down
              if (errorRes?.error?.message) {
                this._notificationService.setMessage({
                  type: AppConstant.MESSAGE_TYPE.ERROR,
                  header: 'Server is unstable',
                  content:
                    'We are sorry, but we encountered an issue on our server. Our team is working to fix it. In the meantime, please refresh and try again.',
                });
              } else {
                // Without Message from server means downtime - Maintenance
                this._notificationService.setMessage({
                  type: AppConstant.MESSAGE_TYPE.ERROR,
                  header: '503',
                  content:
                    'Server is under maintenance please try again later. Thanks you',
                });
                console.log('Error Status Code: ' + 503);
              }

              break;
            }
            default:
              console.log('Error Status Code: ' + errorRes.status);
              break;
          }
        }
        return throwError(() => errorRes?.error);
      })
    );
  }
}
